import { proposalsService } from '@/services/proposals';
import { useQuery } from '@tanstack/react-query';

export function useProposalInspectionDocument(
  policyId: string | undefined,
  type: 'refusal_letter' | 'improvement_letter',
) {
  return useQuery({
    queryKey: ['proposal-inspection-document', policyId, type],
    queryFn: async () => {
      const response = await proposalsService.getInspectionDocument(policyId!, type);
      return response.success && response.data ? response.data : null;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!policyId,
    retry: false,
  });
}
